"use client";

import { TriangleAlert } from "lucide-react";
import { Hint } from "@/components/hint";
import { cn } from "@/lib/utils";
import { t } from "@/lib/localization";
import { useLocale } from "@/hooks/useLocale";

/**
 * Marker for looks/avatars that don't yet advertise HeyGen's Avatar V engine.
 * Due to a HeyGen quirk, V only turns on after the avatar's first video render
 * (which the avatars-pump cron does on avatar_iv), so the tooltip tells the
 * user this is temporary and clears itself after the first generation.
 */
export default function EngineQualityBadge({
    className,
}: {
    className?: string;
}) {
    const { locale } = useLocale();
    return (
        <Hint
            label={t("avatars.engine.no-v-badge.tooltip", locale)}
            side="top"
            align="center"
            tooltipClassName="text-xs font-normal max-w-48 text-center"
        >
            <span
                className={cn(
                    "absolute bottom-1 start-1 inline-flex items-center justify-center rounded-full p-1",
                    "bg-black/60 text-white backdrop-blur-sm ring-1 ring-white/15 shadow-sm",
                    className
                )}
            >
                <TriangleAlert className="size-3" />
            </span>
        </Hint>
    );
}
